import { useEffect, useState } from 'react'

import { CMS_COMPONENT_ACCORDION } from 'shared/consts'
import { stripLeadingSlash } from 'shared/utils/url'
import PillAnimation from 'views/assets/images/animated/animate-pill.svg'
import expander from 'views/assets/scripts/expander'
import Image from 'views/components/atoms/Image'
import NowFaqModalContent from 'views/components/organisms/NowFaqModal/NowFaqModalContent'
import buildClientAPI from 'views/providers/clientAPI'

const NowFaqModalContainer = () => {
  const [accordion, setAccordion] = useState(null)

  useEffect(() => {
    const nowComponents = [CMS_COMPONENT_ACCORDION]
    const { contentService } = buildClientAPI()

    contentService
      .fetchRoute(stripLeadingSlash('premium-lieferung'))
      .then(data => {
        const {
          data: {
            target: {
              content: { body },
            },
          },
        } = data

        const nowCmsComponents = body.filter(component =>
          nowComponents.includes(component.schema)
        )

        setAccordion(
          nowCmsComponents
            .find(component => component.schema === CMS_COMPONENT_ACCORDION)
            .entries.map(entry => ({
              headline: entry.headline.toString(),
              text: entry.items[0].html.toString(),
            }))
        )

        expander()
      })
  }, [])

  if (accordion) {
    return <NowFaqModalContent accordion={accordion} />
  } else {
    return <Image className="blockui--animation" src={PillAnimation} alt="" />
  }
}

export default NowFaqModalContainer
